import React from 'react';
import {
  Alert as AlertCore,
  AlertDescription,
} from '@/lib/components/ui/alert';
import { cn } from '@/lib/lib/utils';

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'destructive';
}

const Alert = (props: AlertProps) => {
  const { children, className, variant, ...rest } = props;

  return (
    <AlertCore
      {...rest}
      variant={variant}
      className={cn('rounded px-4 py-3', className)}
    >
      <AlertDescription>{children}</AlertDescription>
    </AlertCore>
  );
};

export default Alert;
